// Not in use - used with Search and Filter Pro pagination
/*$("#pagination").on("click", "a", function (e) {
	e.preventDefault();
	$(this).remove();
	$("#ajax-loader").load($(this).attr("href") + " #ajax-posts>*", function () {
		$("#ajax-posts").append($("#ajax-loader").html());
	});
	$("#pagination").load($(this).attr("href") + " #pagination>*");
});*/

// Add href attributes to FacetWP pagination links for SEO value
export default function facetwpPagination() {

	// Set up page number next to title
	let $archiveTitle = $('.title-page');
	let $pageFacet = $('.facetwp-page.active');
	let page = $pageFacet.attr('data-page');
	if ($archiveTitle) {
		console.log('page: ' + page);
		if (page > 1) {
			$archiveTitle.html('(page ' + page + ')');
		} else {
			$archiveTitle.html('');
		}
	}

	// Set up pagination hrefs for SEO
	let $pager = $('.facetwp-pager');
	if ($pager) {
		let $pages = $('.facetwp-page');
		$pages.on('click', function(event) {
			event.preventDefault();
		})
		$pages.each(function() {
			if (!$(this).hasClass('dots')) {
				let $url = window.location.href;
				let $dataPage = $(this).attr('data-page');
				// If not on page 1
				if ($url.includes('paged')) {
					// if leading back to page 1, add no "?_param="
					if ($dataPage == 1) {
						$url = location.protocol + '//' + location.host + location.pathname;
						// otherwise, add the param and number
					} else {
						$url = location.protocol + '//' + location.host + location.pathname + '?_paged=' + $dataPage;
					}
					$(this).attr('href', $url);
					// If page 1, add '?_paged=' param to non-first pages
				} else {
					if ($(this).hasClass('first')) {
						$(this).attr('href', $url);
					} else {
						let $pagedUrl = $url + "?_paged=" + $dataPage;
						$(this).attr('href', $pagedUrl);
					}
				}
			}
		});
	}
}
